module.exports = "/_next/static/images/contact-line-b08ca67ec27e33ad338842e3c3da1b0b.svg";